import { render, staticRenderFns } from "./RelatedAccessories.vue?vue&type=template&id=709ae5c8&scoped=true&"
import script from "./RelatedAccessories.vue?vue&type=script&lang=ts&"
export * from "./RelatedAccessories.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedAccessories.vue?vue&type=style&index=0&id=709ae5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ae5c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsSelect: require('/var/www/packages/theme/components/atoms/Select.vue').default,MoleculesRelatedAccessory: require('/var/www/packages/theme/components/molecules/RelatedAccessory.vue').default,MoleculesKESfCarousel: require('/var/www/packages/theme/components/molecules/KESfCarousel.vue').default})
